// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'a8365b48-2586-422b-99cf-8f991a159084',
      type: 'Container',
      name: 'carContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '4a3e6607-252e-4383-9b25-21ed6a65db94',
      type: 'Sprite',
      name: '',
      className: '',
      x: -47,
      y: 57,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.801724,
        y: 1
      },
      angle: 28.1,
      alpha: 1,
      visible: true,
      tint: 2042477,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      mask: null,
      parent: 'a8365b48-2586-422b-99cf-8f991a159084'
    },
    {
      id: 'b4448a42-4a96-40b1-b680-999e15049933',
      type: 'Sprite',
      name: '',
      className: '',
      x: -23,
      y: 38,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.429688,
        y: 0.195313
      },
      angle: 34.1,
      alpha: 1,
      visible: true,
      tint: 2757638,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_256',
      mask: null,
      parent: 'a8365b48-2586-422b-99cf-8f991a159084'
    },
    {
      id: 'bffd60d7-6fbc-4124-a9f0-5261c21a38ff',
      type: 'Container',
      name: 'smokeEmitter',
      className: '',
      x: -138,
      y: 30,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a8365b48-2586-422b-99cf-8f991a159084'
    },
    {
      id: 'e198fe63-aadc-4c59-875a-37e5c9bd92f1',
      type: 'Sprite',
      name: '',
      className: '',
      x: -113,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Big_Car_Wheel_Right_Side',
      mask: null,
      parent: 'a8365b48-2586-422b-99cf-8f991a159084'
    },
    {
      id: 'fa251419-22b0-4446-aabe-4287aceb6942',
      type: 'Container',
      name: '',
      className: '',
      x: -113,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a8365b48-2586-422b-99cf-8f991a159084'
    },
    {
      id: '7d1f2d3a-1e77-471c-bc73-f082142d0f81',
      type: 'Sprite',
      name: '',
      className: '',
      x: -19,
      y: 73,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Big_Car_Wheel_Right_Side',
      mask: null,
      parent: 'a8365b48-2586-422b-99cf-8f991a159084'
    },
    {
      id: '1c625032-d1c9-4f94-bcf5-762f646b68e0',
      type: 'Sprite',
      name: '',
      className: '',
      x: 114,
      y: 43,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Big_Car_Wheel_Left_Side',
      mask: null,
      parent: 'a8365b48-2586-422b-99cf-8f991a159084'
    },
    {
      id: 'a3863c5f-e7ef-4fec-970b-e7baffd5cbdc',
      type: 'Container',
      name: '',
      className: '',
      x: -19,
      y: 73,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a8365b48-2586-422b-99cf-8f991a159084'
    },
    {
      id: '863eaf56-2106-4ba8-8060-cf137185ac54',
      type: 'Container',
      name: '',
      className: '',
      x: 116,
      y: 41,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a8365b48-2586-422b-99cf-8f991a159084'
    },
    {
      id: 'db6a8ea1-678f-4fae-abe3-1c8a9a26f631',
      type: 'Sprite',
      name: 'carBody',
      className: '',
      x: -1,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Big_Car_Body',
      mask: null,
      parent: 'a8365b48-2586-422b-99cf-8f991a159084'
    },
    {
      id: '3b6250a1-0751-40c7-a5b8-a3ffe0b3ee98',
      type: 'Sprite',
      name: 'tireWhoosh',
      className: '',
      x: 6,
      y: -14,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Big_Wheel_Speed_Effect',
      mask: null,
      parent: 'fa251419-22b0-4446-aabe-4287aceb6942'
    },
    {
      id: 'bbdf4fec-dd30-4d46-991c-417f10a43e23',
      type: 'Sprite',
      name: 'tireWhoosh2',
      className: '',
      x: 6,
      y: -14,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Big_Wheel_Speed_Effect',
      mask: null,
      parent: 'a3863c5f-e7ef-4fec-970b-e7baffd5cbdc'
    },
    {
      id: '26536583-4f2f-4f45-a3c9-75d1960c7585',
      type: 'Sprite',
      name: 'tireWhoosh3',
      className: '',
      x: 6,
      y: -14,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Big_Wheel_Speed_Effect',
      mask: null,
      parent: '863eaf56-2106-4ba8-8060-cf137185ac54'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  animations: [
    {
      id: 'edc1102a-e2ca-437e-83c4-e060a32a0767',
      name: 'Tires_Idle',
      playingSpeed: 1,
      totalDuration: 200,
      blocks: [
        {
          id: '977d00c9-b93a-4967-8b25-da82d5806a05',
          type: 'Setter',
          name: 'tire_1_setter',
          track: 1,
          target: {
            x: 11,
            y: 0,
            angle: 19,
            alpha: 0
          },
          startAt: 0,
          sourceName: 'tireWhoosh',
          disabled: false
        },
        {
          id: '582fa566-521f-4808-ab09-2d9b188b4d2d',
          type: 'Setter',
          name: 'tire_2_setter',
          track: 5,
          target: {
            x: 11,
            y: 0,
            angle: 19,
            alpha: 0
          },
          startAt: 0,
          sourceName: 'tireWhoosh2',
          disabled: false
        },
        {
          id: '3b023e41-ae6f-42d1-b09c-927bf002d80b',
          type: 'Setter',
          name: 'tire_3_setter',
          track: 13,
          target: {
            x: 11,
            y: 0,
            angle: 19,
            alpha: 0
          },
          startAt: 0,
          sourceName: 'tireWhoosh3',
          disabled: false
        },
        {
          id: 'f813c2e1-fd5a-4a15-9914-37dff581fcde',
          type: 'Tween',
          name: 'tire_1_position',
          duration: 200,
          track: 2,
          target: {
            x: 3,
            y: -23,
            angle: -1
          },
          startAt: 0,
          sourceName: 'tireWhoosh',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '6f5302d3-104f-46b9-9194-600359219517',
          type: 'Tween',
          name: 'tire_1_fadeIn',
          duration: 100,
          track: 3,
          target: {
            alpha: 0.2
          },
          startAt: 0,
          sourceName: 'tireWhoosh',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: 'c56c87b9-d079-4886-9ab9-6fd05b2975a4',
          type: 'Tween',
          name: 'tire_2_position',
          duration: 200,
          track: 6,
          target: {
            x: 3,
            y: -23,
            angle: -1
          },
          startAt: 0,
          sourceName: 'tireWhoosh2',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '52968fcf-93b6-4495-8cac-e176ba0b0e28',
          type: 'Tween',
          name: 'tire_2_fadeIn',
          duration: 100,
          track: 8,
          target: {
            alpha: 0.2
          },
          startAt: 0,
          sourceName: 'tireWhoosh2',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '61e870dc-99c2-4836-bfd2-fc1caf953ecd',
          type: 'Tween',
          name: 'tire_3_position',
          duration: 200,
          track: 14,
          target: {
            x: 3,
            y: -23,
            angle: -1
          },
          startAt: 0,
          sourceName: 'tireWhoosh3',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '59fa9550-882b-4d11-a8d7-ef1a0e0b4b37',
          type: 'Tween',
          name: 'tire_3_fadeIn',
          duration: 100,
          track: 15,
          target: {
            alpha: 0.2
          },
          startAt: 0,
          sourceName: 'tireWhoosh3',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '4719a4e7-1893-4087-9ea2-a4e07aced3bb',
          type: 'Tween',
          name: 'tire_1_fadeOut',
          duration: 100,
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'tireWhoosh',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '96ee1888-ccb4-41c2-ab9c-1bbb43558074',
          type: 'Tween',
          name: 'tire_2_fadeOut',
          duration: 100,
          track: 8,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'tireWhoosh2',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: 'b1b70e9c-665e-42a9-9044-9be4df8e114d',
          type: 'Tween',
          name: 'tire_3_fadeOut',
          duration: 100,
          track: 15,
          target: {
            alpha: 0
          },
          startAt: 100,
          sourceName: 'tireWhoosh3',
          easing: 'QuadraticOut',
          disabled: false
        }
      ]
    },
    {
      id: '6aa0db06-54c3-4358-a7e4-7c544b69c08f',
      name: 'Car_Idle',
      playingSpeed: 1,
      totalDuration: 500,
      blocks: [
        {
          id: 'e0e0d21a-3cca-4c0e-8d7b-3f9c9c8533dc',
          type: 'Tween',
          name: 'New_tween',
          duration: 250,
          track: 2,
          target: {
            pivot: {
              y: 3
            }
          },
          startAt: 0,
          sourceName: 'carBody',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '2b095d40-4fd5-4aa3-aef8-49ac38d3d3ef',
          type: 'Tween',
          name: 'New_tween_copy',
          duration: 250,
          track: 2,
          target: {
            pivot: {
              y: 0
            }
          },
          startAt: 250,
          sourceName: 'carBody',
          easing: 'SinusoidalIn',
          disabled: false
        }
      ]
    },
    {
      id: 'c9174811-ccee-45be-aa98-8ca870da92fe',
      name: 'Car_Idle_2',
      playingSpeed: 1,
      totalDuration: 1200,
      blocks: [
        {
          id: 'ebbad6a0-881f-48f6-99ca-eb067676eaf6',
          type: 'Tween',
          name: 'car_move',
          duration: 600,
          track: 3,
          target: {
            x: -9,
            y: 12
          },
          startAt: 0,
          sourceName: 'carContainer',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '77eb87a7-be9a-4aea-9ff2-2aefff670fb4',
          type: 'Tween',
          name: 'car_move_2',
          duration: 600,
          track: 3,
          target: {
            x: 0,
            y: 0
          },
          startAt: 600,
          sourceName: 'carContainer',
          easing: 'SinusoidalInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class RaceEventBigCarLayout {
  static raw = raw;
  root!: Container;
  carContainer!: Container;
  smokeEmitter!: Container;
  carBody!: Sprite;
  tireWhoosh!: Sprite;
  tireWhoosh2!: Sprite;
  tireWhoosh3!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Tires_Idle {
  Layout: {
    tireWhoosh: object;
    tireWhoosh2: object;
    tireWhoosh3: object;
  };

  BlockTypeByName: {
    tire_1_setter: object;
    tire_2_setter: object;
    tire_3_setter: object;
    tire_1_position: object;
    tire_1_fadeIn: object;
    tire_2_position: object;
    tire_2_fadeIn: object;
    tire_3_position: object;
    tire_3_fadeIn: object;
    tire_1_fadeOut: object;
    tire_2_fadeOut: object;
    tire_3_fadeOut: object;
  };

  flowData = raw.animations[0];
}

export abstract class Car_Idle {
  Layout: {
    carBody: object;
  };

  BlockTypeByName: {
    New_tween: object;
    New_tween_copy: object;
  };

  flowData = raw.animations[1];
}

export abstract class Car_Idle_2 {
  Layout: {
    carContainer: object;
  };

  BlockTypeByName: {
    car_move: object;
    car_move_2: object;
  };

  flowData = raw.animations[2];
}
